export default function MainActivities({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Main Activities")}</legend>
      <input
        className="form-control fontsize-legend"
        name="mainActivities"
        onChange={onChange}
        value={searchObject.mainActivities || ""}
      />
    </div>
  );
}
